import { render, staticRenderFns } from "./AgentConnections.vue?vue&type=template&id=1c58974c&scoped=true"
import script from "./AgentConnections.vue?vue&type=script&lang=js"
export * from "./AgentConnections.vue?vue&type=script&lang=js"
import style0 from "./AgentConnections.vue?vue&type=style&index=0&id=1c58974c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c58974c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c58974c')) {
      api.createRecord('1c58974c', component.options)
    } else {
      api.reload('1c58974c', component.options)
    }
    module.hot.accept("./AgentConnections.vue?vue&type=template&id=1c58974c&scoped=true", function () {
      api.rerender('1c58974c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/dashboardSolicitudes/components/AgentConnections.vue"
export default component.exports